<template>
  <header class="header">
    <div class="container">
      <Logo />
      <Navigation />
      <div class="header-right">
        <ContactInfo />
        <SocialMedia />
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import Logo from "./components/Logo.vue";
import Navigation from "./components/Navigation.vue";
import ContactInfo from "./components/ContactInfo.vue";
import SocialMedia from "./components/SocialMedia.vue";
</script>

<style scoped>
/* 头部样式 */
.header {
  background-color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.header .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  gap: 20px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* 平板端适配 */
@media (max-width: 1024px) {
  .header .container {
    padding: 0 15px;
  }
  
  .header-right {
    gap: 15px;
  }
}

/* 移动端适配 */
@media (max-width: 768px) {
  .header .container {
    height: 60px;
    padding: 0 15px;
    gap: 10px;
  }
  
  .header-right {
    display: none; /* 移动端隐藏联系方式和社交媒体 */
  }
}

/* 超小屏幕适配 */
@media (max-width: 480px) {
  .header .container {
    height: 56px;
    padding: 0 10px;
  }
}
</style>
